import { Box, Skeleton } from '@machobear/design-system'
import { ActiveSponsor } from './active-sponsor'
import { UpcomingSponsor } from './upcoming-sponsor'
import { PastSponsor } from './past-sponsor'
import { NoSponsor } from './no-sponsor'
import { useListingData } from '../../../context/listing-data'

export const BoostListing = () => {
  const { listingSponsored, currentSponsorship = {}, loading } = useListingData()

  if (loading)
    return (
      <Box paddingY="xxsmall">
        <Skeleton.Shape width="100%" height="100px" />
      </Box>
    )

  if (currentSponsorship.state_machine === 'active') {
    return <ActiveSponsor />
  }

  if (currentSponsorship.state_machine === 'open') {
    return <UpcomingSponsor />
  }

  if (listingSponsored) {
    return <PastSponsor />
  }

  return <NoSponsor />
}
